import { render, staticRenderFns } from "./historyCardMgt.vue?vue&type=template&id=51b082dd&scoped=true&"
import script from "./historyCardMgt.vue?vue&type=script&lang=js&"
export * from "./historyCardMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b082dd",
  null
  
)

export default component.exports